import React, { useEffect, useState } from 'react';
import { contractAddress } from "../../config/BackendUrl"; // Importing contract address from configuration
import DynamicNFTCard from './DynamicCard'; // Component to render individual NFT cards
import CardPlaceholder from '../cards/NFTCardPlaceholder'; // Placeholder component for loading state
import { listNFTs } from '../../hooks/NFTHook'; // API hook to fetch NFTs

function UserCardMarketplace(props) {
  // Retrieve wallet address and user ID from local storage
  const userWalletAddress = localStorage.getItem("WalletAddress");
  const userIds = localStorage.getItem("userId");

  // State variables
  const [nfts, setNfts] = useState([]); // State to store NFTs fetched for the user
  const [hasMore, setHasMore] = useState(true); // Flag to determine if there are more NFTs to load

  // `useEffect` runs on component mount to fetch NFTs if a wallet address is present
  useEffect(() => {
    // if (userWalletAddress) {
      fetchUserNFTs();
    // } else {
      // setHasMore(false); // If wallet is not connected, stop further actions
    // }
  }, [props.filter]);

  // Function to fetch NFTs owned by the user
  const fetchUserNFTs = async () => {
    let Params;
    if (props.filter === "latest") {
      Params = {
        page: 1,
        limit: 8,
        ownerAddress: userWalletAddress,
        contractAddress: contractAddress // Fetch NFTs for a specific contract address
      };
    }
    else {
      Params = {
        page: 1,
        limit: 8,
        category: props.filter,
        ownerAddress: userWalletAddress,
        contractAddress: contractAddress // Fetch NFTs for a specific contract address
      };
    }

    const allNFTs = await listNFTs(Params); // Fetch NFTs using the API
console.log("All NFTs", allNFTs, Params);

    if (allNFTs.success === true) {
      const NFTs = allNFTs.data;

      // Add a `isLike` flag to each NFT based on whether the user has liked it
      const AddIsLikeFlag = NFTs.map(item => {
        const isLike = item.likes.some(like =>
          like.userId === userIds // Check if the user's ID exists in the likes array
        );

        return { ...item, isLike }; // Merge the `isLike` flag into the NFT object
      });
      setTimeout(() => {
        setNfts(AddIsLikeFlag); // Update the state with the processed NFTs
        // If no NFTs are found, set the `hasMore` flag to false
        if (AddIsLikeFlag.length === 0) {
          setHasMore(false);
        }
      }, 2000);

    }
    else{
      setHasMore(false)
    }
  };
  console.log("props at User", props, userWalletAddress, nfts);


  return (
    <>
      <div className="row">
        {nfts.length > 0 ? (
          // Render NFT cards if NFTs are available
          nfts.map((val, i) => (
            <div key={i} className="col-lg-3 col-md-4 col-sm-6 card-hover-effect">
              <DynamicNFTCard
                NFTLink={`/nftdetails/${val.contractAddress}/${val._id}`} // Dynamic link for NFT details
                contractAddress={val.contractAddress}
                currentOwnerPic={val?.currentOwner?.userId?.profilePicture} // Owner's profile picture
                currentOwnerName={val?.currentOwner?.userId?.name} // Owner's name
                currentOwnerLink={val?.currentOwner?.walletAddress !== userWalletAddress ? `/otherProfile/${val?.currentOwner?.walletAddress}` : "/profile"} // Owner profile link
                mediaUrl={val.imageUri} // Media URL (image or video)
                assetType={val.assetType} // Asset type: image or video
                title={val.title} // Title of the NFT
                price={val.price} // Price of the NFT
                likes={val.totalLikes} // Total likes for the NFT
                isLiked={val.isLike} // Flag to indicate if the NFT is liked by the user
                tokenId={val.tokenId} // NFT Token ID
                isListed={val.listed} // Flag to indicate if the NFT is listed for sale
                nftId={val._id} // Unique ID of the NFT
                type={val.type}
              />
            </div>
          ))
        ) : (
          // If no NFTs are available, show a loading state or message
          hasMore ? (
            // Show placeholders while fetching data
            <>
              {[...Array(8)].map((_, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                  <CardPlaceholder /> {/* Skeleton loader for NFT cards */}
                </div>
              ))}
            </>
          ) : (
            // Show a message when no NFTs are available
            <h3>
              {userWalletAddress ?
                "No NFT Available" : "Wallet Not Connected !!!" // Message depends on wallet connection status
              }
            </h3>
          )
        )}
      </div>
    </>
  );
}

export default UserCardMarketplace;
